import { PROCUREMENT_LOGIN } from '../constants/breadcrumb.constants';

// Case-insensitively matches the trailing segments of `pathname` against every known PROCUREMENT_LOGIN
// value (whatever its segment count) and returns the pathname rewritten to the canonical casing, or null
// if the path doesn't correspond to a procurement login (or already matches exactly).
export const normalizeProcurementCasing = (pathname: string): string | null => {
    const segments = pathname.split('/').filter(Boolean);

    for (const canonicalPath of Object.values(PROCUREMENT_LOGIN)) {
        const canonicalSegments = canonicalPath.split('/');

        if (segments.length < canonicalSegments.length) {
            continue;
        }

        const candidateSegments = segments.slice(segments.length - canonicalSegments.length);
        const candidatePath = candidateSegments.join('/');

        if (candidatePath === canonicalPath) {
            return null;
        }

        if (candidatePath.toLowerCase() === canonicalPath.toLowerCase()) {
            const prefixSegments = segments.slice(0, segments.length - canonicalSegments.length);
            return `/${[...prefixSegments, ...canonicalSegments].join('/')}`;
        }
    }

    return null;
};
